import { render, staticRenderFns } from "./default_ball.vue?vue&type=template&id=6642c306&scoped=true"
import script from "./default_ball.vue?vue&type=script&lang=js"
export * from "./default_ball.vue?vue&type=script&lang=js"
import style0 from "./default_ball.vue?vue&type=style&index=0&id=6642c306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6642c306",
  null
  
)

export default component.exports